import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))


    return (
        <ul class="results-grid results-grid--default list-inline" data-grid="" data-results-grid="" data-layout-mobile="2" data-layout-mobile-alt="1" data-layout-desktop="4" data-layout-desktop-alt="2" data-image-sizes-alt="(min-width: 61.875rem) calc(100vw / 2), 100vw">
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </ul>
    )
}
